
export class ExclusaoAgendamento{
  codigoAgendamento:number;
  codigoUsuario:number;

}
